import { motion, useInView } from "framer-motion"
import { Link, graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import { Autoplay, EffectCoverflow, FreeMode, Navigation, Thumbs } from "swiper"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"
import ImageOpt from "./ImageOpt"

const GallerySlider = ({ module }) => {
  const ref = useRef(null)
  const [hasPlayed, setHasPlayed] = useState(false)
  const isInView = useInView(ref)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  // Swiper Buttons handler
  const handleNextClick = selector => {
    const swiper = document.querySelector(selector).swiper
    swiper.slideNext()
  }
  const handlePrevClick = selector => {
    const swiper = document.querySelector(selector).swiper
    swiper.slidePrev()
  }
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  if (module.hideSection === "no") {
    if (module.sectionStyle === "layout1") {
      return (
        <React.Fragment>
          <motion.section
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className={`gallery-slider py-75 xlscreen:py-50 mdscreen:py-35 relative ${module.extraClass ? ` ${module.extraClass}` : ""
              }`}
            id={module.extraId}
          >
            <motion.div
              ref={ref}
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
              className="container-fluid-xl"
            >
              <div className="flex justify-between flex-wrap">
                <div className="title-wrapper w-8/12 lgscreen:w-full">
                  {/* {module?.preHeading && (
                    <motion.div
                      variants={animFade}
                      className="pre-heading grey-separator-right"
                    >
                      <span>{module.preHeading}</span>
                    </motion.div>
                  )}
                  {module?.heading && (
                    <div className="title title-grey pt-35 mdscreen2:pt-0 uppercase">
                      <motion.h2 variants={animFade}>
                        {module.heading}
                      </motion.h2>
                    </div>
                  )}
                  {module?.description && (
                    <motion.div variants={animFade} className="content pt-15 md2:max-w-[736px]">
                      <p>{parse(module.description)}</p>
                    </motion.div>
                  )} */}
                  <Swiper
                    onSwiper={setThumbsSwiper}
                    spaceBetween={10}
                    slidesPerView={1}
                    speed={1500}
                    loop={true}
                    freeMode={false}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className="!pl-5"
                  >
                    <SwiperSlide>
                      {module?.preHeading && (
                        <motion.div
                          variants={animFade}
                          className="pre-heading grey-separator-right"
                        >
                          <span>{module.preHeading}</span>
                        </motion.div>
                      )}
                      {module?.heading && (
                        <div className="title title-grey pt-35 mdscreen2:pt-0 uppercase">
                          <motion.h2 variants={animFade}>
                            {module.heading}
                          </motion.h2>
                        </div>
                      )}
                      {module?.description && (
                        <motion.div variants={animFade} className="content pt-15 md2:max-w-[736px]">
                          <p>{parse(module.description)}</p>
                        </motion.div>
                      )}
                    </SwiperSlide>
                    <SwiperSlide>
                      {module?.preHeading && (
                        <motion.div
                          variants={animFade}
                          className="pre-heading grey-separator-right"
                        >
                          <span>{module.preHeading}</span>
                        </motion.div>
                      )}
                      {module?.heading && (
                        <div className="title title-grey pt-35 mdscreen2:pt-0 uppercase">
                          <motion.h2 variants={animFade}>
                            {module.heading}
                          </motion.h2>
                        </div>
                      )}
                      {module?.description && (
                        <motion.div variants={animFade} className="content pt-15 md2:max-w-[736px]">
                          <p>{parse(module.description)}</p>
                        </motion.div>
                      )}
                    </SwiperSlide>
                    <SwiperSlide>
                      {module?.preHeading && (
                        <motion.div
                          variants={animFade}
                          className="pre-heading grey-separator-right"
                        >
                          <span>{module.preHeading}</span>
                        </motion.div>
                      )}
                      {module?.heading && (
                        <div className="title title-grey pt-35 mdscreen2:pt-0 uppercase">
                          <motion.h2 variants={animFade}>
                            {module.heading}
                          </motion.h2>
                        </div>
                      )}
                      {module?.description && (
                        <motion.div variants={animFade} className="content pt-15 md2:max-w-[736px]">
                          <p>{parse(module.description)}</p>
                        </motion.div>
                      )}
                    </SwiperSlide>
                    <SwiperSlide>
                      {module?.preHeading && (
                        <motion.div
                          variants={animFade}
                          className="pre-heading grey-separator-right"
                        >
                          <span>{module.preHeading}</span>
                        </motion.div>
                      )}
                      {module?.heading && (
                        <div className="title title-grey pt-35 mdscreen2:pt-0 uppercase">
                          <motion.h2 variants={animFade}>
                            {module.heading}
                          </motion.h2>
                        </div>
                      )}
                      {module?.description && (
                        <motion.div variants={animFade} className="content pt-15 md2:max-w-[736px]">
                          <p>{parse(module.description)}</p>
                        </motion.div>
                      )}
                    </SwiperSlide>
                  </Swiper>
                </div>
                {module?.button && (
                  <div className="custom-btn w-4/12 lgscreen:w-full flex items-end justify-end lgscreen:pt-35 lgscreen:justify-start">
                    <motion.div variants={animFade}>
                      <Link
                        to={module.button.url}
                        className="btn btn-grey"
                        target={module.button.target}
                      >
                        {module.button.title}
                      </Link>
                    </motion.div>
                  </div>
                )}
              </div>
            </motion.div>
            {module?.images && (
              <motion.div
                variants={animFade}
                className="gallery-slider-main pt-50 smscreen2:container-fluid"
              >
                <div className="relative">
                  <Swiper
                    loop={true}
                    slidesPerView={"4"}
                    speed={1500}
                    thumbs={{ swiper: thumbsSwiper }}
                    effect={'coverflow'}
                    coverflowEffect={{
                      rotate: 0,
                      stretch: 0,
                      depth: 420,
                      modifier: 1,
                      slideShadows: false,
                    }}
                    centeredSlides={true}
                    modules={[Autoplay, Navigation, EffectCoverflow, FreeMode, Thumbs]}
                    breakpoints={{
                      0: {
                        slidesPerView: 1,
                        spaceBetween: '15%',
                      },
                      641: {
                        slidesPerView: 1.45,
                        spaceBetween: '18%',
                      },
                    }}
                    navigation={{
                      nextEl: `.gallery_swiperBtn_next-1`,
                      prevEl: `.gallery_swiperBtn_prev-1`,
                      disabledClass: "btn-disabled",
                    }}
                  >
                    {module.images.concat(module.images).map((item, i) => (
                      <SwiperSlide key={i}>
                        {item?.image && (
                          <div className="border-bg-offwhite">
                            <div className="img">
                              <ImageOpt
                                imgData={item.image.mediaItemUrl}
                                imgAlt={item.image.title}
                                imgClass=""
                                width={2000}
                                height={1000}
                                imgLoad="lazy"
                              />
                            </div>
                          </div>
                        )}
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <div className="swiper-arrow flex gap-x-5">
                    <button
                      className="absolute left-30 top-50per translate-y-minus_50 z-9 w-[42px] h-[42px] lgscreen:w-[35px] lgscreen:h-[35px] rounded-100 bg-opacity-10 border-2 border-white-100 flex flex-wrap justify-center items-center transition-all duration-300 gallery_swiperBtn_prev-1"
                    >
                      <img
                        src="../../images/swiper-arrowPrev-white.svg"
                        width={20}
                        height={20}
                        loading="lazy"
                        alt="Arrow"
                      />
                    </button>
                    <button
                      className="absolute right-30 top-50per translate-y-minus_50 z-9 w-[42px] h-[42px] lgscreen:w-[35px] lgscreen:h-[35px] rounded-100 bg-opacity-10 border-2 border-white-100 flex flex-wrap justify-center items-center transition-all duration-300 gallery_swiperBtn_next-1"
                    >
                      <img
                        src="../../images/swiper-arrowNext-white.svg"
                        width={20}
                        height={20}
                        loading="lazy"
                        alt="Arrow"
                      />
                    </button>
                  </div>
                </div>
              </motion.div>
            )}
          </motion.section>
        </React.Fragment>
      )
    }
    if (module.sectionStyle === "layout2") {
      return (
        <React.Fragment>
          <motion.section
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className={`general-content-slider py-95 xlscreen:py-80 mdscreen2:py-50 bg-white-200 ${module.extraClass ? ` ${module.extraClass}` : ""
              }`}
            id={module.extraId}
          >
            <motion.div
              ref={ref}
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
            >
              <div className="container-fluid-sm">
                <motion.div
                  variants={animFade}
                  className="title title-grey grey-separator-both"
                >
                  {module?.heading && (
                    <div className="uppercase tracking-0.04em">
                      <h2>{module.heading}</h2>
                    </div>
                  )}
                </motion.div>
                {module?.description && (
                  <motion.div
                    variants={animFade}
                    className="max-w-[860px] mx-auto pt-20 text-center"
                  >
                    <p>{parse(module.description)}</p>
                  </motion.div>
                )}
              </div>
              {module?.images && (
                <motion.div
                  variants={animFade}
                  className="gallery-slider pt-55 mdscreen:pt-35 relative"
                >
                  <div className="gallery-slider-main smscreen2:container-fluid">
                    <div className="relative">
                      <Swiper
                        loop={true}
                        slidesPerView={"4"}
                        speed={1500}
                        effect={'coverflow'}
                        coverflowEffect={{
                          rotate: 0,
                          stretch: 0,
                          depth: 420,
                          modifier: 1,
                          slideShadows: false,
                        }}
                        centeredSlides={true}
                        modules={[Autoplay, Navigation, EffectCoverflow]}
                        breakpoints={{
                          0: {
                            slidesPerView: 1,
                            spaceBetween: '15%',
                          },
                          641: {
                            slidesPerView: 1.45,
                            spaceBetween: '18%',
                          },
                        }}
                      >
                        {module.images.concat(module.images).map((item, i) => (
                          <SwiperSlide key={i}>
                            {item?.image && (
                              <div className="img">
                                <ImageOpt
                                  imgData={item.image.mediaItemUrl}
                                  imgAlt={item.image.title}
                                  imgClass=""
                                  width={2000}
                                  height={1000}
                                  imgLoad="lazy"
                                />
                                {item?.imageCaption && (
                                  <div className="caption absolute bottom-0 left-0 w-full px-30 pb-20 z-9">
                                    <span className="text-white-100 text-14 leading-18 italic">
                                      {item.imageCaption}
                                    </span>
                                  </div>
                                )}
                              </div>
                            )}
                          </SwiperSlide>
                        ))}
                      </Swiper>
                      <div className="swiper-arrow flex gap-x-5">
                        <button
                          className="absolute left-30 top-50per translate-y-minus_50 z-9 w-[42px] h-[42px] lgscreen:w-[35px] lgscreen:h-[35px] rounded-100 bg-opacity-10 border-1 border-white-100 flex flex-wrap justify-center items-center transition-all duration-300"
                          onClick={() =>
                            handlePrevClick(".gallery-slider .swiper")
                          }
                        >
                          <img
                            src="../../images/swiper-arrowPrev-white.svg"
                            width={20}
                            height={20}
                            loading="lazy"
                            alt="Arrow"
                          />
                        </button>
                        <button
                          className="absolute right-30 top-50per translate-y-minus_50 z-9 w-[42px] h-[42px] lgscreen:w-[35px] lgscreen:h-[35px] rounded-100 bg-opacity-10 border-1 border-white-100 flex flex-wrap justify-center items-center transition-all duration-300"
                          onClick={() =>
                            handleNextClick(".gallery-slider .swiper")
                          }
                        >
                          <img
                            src="../../images/swiper-arrowNext-white.svg"
                            width={20}
                            height={20}
                            loading="lazy"
                            alt="Arrow"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </motion.div>
              )}
            </motion.div>
          </motion.section>
        </React.Fragment>
      )
    }
    if (module.sectionStyle === "layout3") {
      return (
        <React.Fragment>
          <motion.section
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className={`facility-slider py-60 smscreen:!pb-15 style-grey ${module.background === "no" ? "" : "bg-white-200"
              } bg-opacity-40 ${module.extraClass ? ` ${module.extraClass}` : ""
              }`}
            id={module.extraId}
          >
            <motion.div
              ref={ref}
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
            >
              <div className="container-fluid-md2">
                {module?.images && (
                  <motion.div variants={animFade} className="slider-main">
                    <div className="relative px-80 mdscreen:px-40 smscreen:px-0">
                      <Swiper
                        slidesPerView={2}
                        speed={1000}
                        modules={[Autoplay, Navigation]}
                        navigation={{
                          nextEl: ".facility_nextBtn-1",
                          prevEl: ".facility_prevBtn-1",
                          disabledClass: "btn-disabled",
                        }}
                        breakpoints={{
                          0: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                          },
                          768: {
                            spaceBetween: 20,
                            slidesPerView: 2,
                          },
                        }}
                      >
                        {module?.images.map((item, i) => (
                          <SwiperSlide key={i}>
                            <div className="border-bg border-bg-offwhite">
                              {item?.image && (
                                <div className="img">
                                  <ImageOpt
                                    imgData={item.image.mediaItemUrl}
                                    imgAlt={item.image.title}
                                    imgClass=""
                                    width={2000}
                                    height={1000}
                                    imgLoad="lazy"
                                  />
                                  {item?.imageCaption && (
                                    <div className="caption absolute bottom-0 left-0 w-full px-30 pb-20">
                                      <span className="text-white-100 text-14 leading-18 italic">
                                        {item.imageCaption}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                      <div className="swiper-arrow flex gap-x-5 smscreen:mt-40 smscreen:justify-end smscreen:gap-x-15">
                        <button className="swiper-btn !bg-[inherit] absolute smscreen:static left-0 top-50per translate-y-minus_50 z-9 w-[42px] h-[42px] lgscreen:w-[35px] lgscreen:h-[35px] rounded-100 bg-opacity-10 border-2 border-white-100 flex flex-wrap justify-center items-center transition-all duration-300 facility_prevBtn-1">
                          <img
                            src="../../images/swiper-arrowPrev-white.svg"
                            width={20}
                            height={20}
                            loading="lazy"
                            alt="Arrow"
                          />
                        </button>
                        <button className="swiper-btn !bg-[inherit] absolute smscreen:static right-0 top-50per translate-y-minus_50 z-9 w-[42px] h-[42px] lgscreen:w-[35px] lgscreen:h-[35px] rounded-100 bg-opacity-10 border-2 border-white-100 flex flex-wrap justify-center items-center transition-all duration-300 facility_nextBtn-1">
                          <img
                            src="../../images/swiper-arrowNext-white.svg"
                            width={20}
                            height={20}
                            loading="lazy"
                            alt="Arrow"
                          />
                        </button>
                      </div>
                    </div>
                  </motion.div>
                )}
              </div>
            </motion.div>
          </motion.section>
        </React.Fragment>
      )
    }
  }
}

export default GallerySlider
export const PageGallerySliderFragment = graphql`
  fragment PageGallerySliderFragment on WpPage_Pagecontent_PageContent_GallerySlider {
    extraClass
    extraId
    hideSection
    description
    background
    button {
      target
      title
      url
    }
    heading
    preHeading
    sectionStyle
    images {
      image {
        altText
        mediaItemUrl
        title
      }
      imageCaption
    }
  }
`
export const ExperienceGallerySliderFragment = graphql`
  fragment ExperienceGallerySliderFragment on WpExperiences_Experiencecontent_ExperienceContent_GallerySlider {
    extraClass
    extraId
    hideSection
    description
    background
    button {
      target
      title
      url
    }
    heading
    preHeading
    sectionStyle
    images {
      image {
        altText
        mediaItemUrl
        title
      }
      imageCaption
    }
  }
`
export const DestinationGallerySliderFragment = graphql`
  fragment DestinationGallerySliderFragment on WpDestination_Destinationcontent_DestinationContent_GallerySlider {
    extraClass
    extraId
    hideSection
    description
    background
    button {
      target
      title
      url
    }
    heading
    preHeading
    sectionStyle
    images {
      image {
        altText
        mediaItemUrl
        title
      }
      imageCaption
    }
  }
`
export const OffersGallerySliderFragment = graphql`
  fragment OffersGallerySliderFragment on WpOffers_Offerscontent_OffersContent_GallerySlider {
    extraClass
    extraId
    hideSection
    description

    heading
    preHeading
    sectionStyle
    images {
      image {
        altText
        mediaItemUrl
        title
      }
      imageCaption
    }
  }
`
